export enum EventName {
    REDIRECTION = 'REDIRECCION',
    TASK = 'TASK',
    SIGN_OUT = 'DESCONECTARCE',
    LOG_IN = 'INICIAR-SESION',
    IMAGE_RECOVERY_PASS = 'IMAGE-RECOVERY-PASSWORD',
    EDIT = 'EDITAR',
    REFRESH_LIST = 'ACTUALIZAR-LISTADO',
    FILTER_OPERATIONS = 'FILTRAR-OPERACIONES',
    COUNTRY = 'PAISES',
    UPDATE_VALUATION = 'UPDATE-VALUATION',
    REFRESH_TIMER = 'REFRESH-TIMER',
    UPDATE_LAST_VALUATION = 'UPDATE-LAST-VALUATION',
    SAVING_OPERATION = 'SAVING-OPERATION',
    ANALYTICS = 'ANALYTICS',
    CHANGE_TAB = 'CHANGE_TAB',
    REFRESH_MOUNTS = 'REFRESH_MOUNTS',
    SHOW_TIME_ALERTS = 'SHOW_TIME_ALERTS',
    TIMER_UPDATE = 'TIMER_UPDATE'
}
